import { types } from './actions';

const initialState = {
  customTables: [],
  isCreating: false,
  isModalOpen: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.INIT:
      return {
        ...state,
        customTables: payload.customTables,
      };
    case types.CREATE_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: true,
      };
    case types.CREATE_MODAL_CLOSE:
      return {
        ...state,
        isModalOpen: false,
      };
    case types.CREATE_CUSTOM_TABLE_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.CREATE_CUSTOM_TABLE_SUCCESS:
      return {
        ...state,
        customTables: state.customTables.concat([payload.customTable]),
        isCreating: false,
      };
    case types.CREATE_CUSTOM_TABLE_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.supplierTables.listPage;

export const getCustomTables = (state) => getScope(state).customTables;

export const getIsCreating = (state) => getScope(state).isCreating;

export const getIsModalOpen = (state) => getScope(state).isModalOpen;
